<template>
  <div>
    <div class="title-container">
      <h3 :class="!mediumSelected ? ['error-text'] : ''">
        Opleverwijze
      </h3>
    </div>

    <div class="medium-select">
      <div class="select-row">
        <select-box
          @action="setMedium('email')"
          :selected="medium.isEmail"
        ></select-box>
        <span class="pointer" @click="setMedium('email')">Via e-mail</span>
        <input
          v-show="medium.isEmail"
          type="text"
          name="email"
          placeholder="Voer een emailadres in"
          @input="setEmailAddress($event.target.value)"
          :value="medium.emailAddress"
        />
      </div>
      <div class="select-row">
        <select-box
          @action="setMedium('disk')"
          :selected="medium.isDisk"
        ></select-box>
        <span class="pointer" @click="setMedium('disk')"
          >Op schijf (usb of hdd)</span
        >
      </div>

      <div class="select-row">
        <select-box
          @action="setMedium('other')"
          :selected="medium.isOther"
        ></select-box>
        <span class="pointer" @click="setMedium('other')"
          >Anders, vul in bij
          <span
            class="pointer otherlink"
            @click.stop="$emit('goToInstructions')"
            >opdrachtomschrijving</span
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['medium'],
  data() {
    return {}
  },
  methods: {
    setEmailAddress(email) {
      const newMedium = { ...this.medium }
      newMedium.emailAddress = email
      this.$emit('updateOrder', ['medium', newMedium])
    },
    setMedium(val) {
      const newMedium = { ...this.medium }
      switch (val) {
        case 'disk':
          newMedium.isDisk = !newMedium.isDisk
          break
        case 'other':
          newMedium.isOther = !newMedium.isOther
          break
        case 'email':
          newMedium.isEmail = !newMedium.isEmail
          newMedium.emailAddress = newMedium.isEmail
            ? this.rootStore.user.username
            : ''
          break
      }
      this.$emit('updateOrder', ['medium', newMedium])
    }
  },
  computed: {
    mediumSelected() {
      if (this.medium.isDisk || this.medium.isEmail || this.medium.isOther) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-row {
  margin: 15px 0;
}
.otherlink {
  color: var(--sub-color);
  font-weight: 500;
}

.sub-holder {
  padding-left: 20px;
  margin-top: -3px;
}

input {
  margin-bottom: 0;
  margin-left: 5px;
}
</style>
